document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM Loaded');
    // Assuming you have a reference to the element with class .tab-accordion-system .system
    const sortingElement = document.querySelectorAll('.sorting');
    
    sortingElement.forEach(function(systemElement) {
        systemElement.addEventListener('click', function() {
            systemElement.classList.toggle('opened');
        });
    });

    // Assuming you have a reference to the element with class .tab-accordion-system .system
    const systemElements = document.querySelectorAll('.utility-content .inner-wrapper .tab-accordion-system .system');
    
    systemElements.forEach(function(systemElement) {
        systemElement.addEventListener('click', function() {
            systemElement.classList.toggle('active');
        });
    });

    const searchIcon = document.querySelector('.block-search-scroll');
    const searchBarScroll = document.querySelector('.scroll-search-container');

    searchIcon.addEventListener('click', function() {
        searchBarScroll.classList.toggle('opened');
    });

});
